import React, { useEffect, useState, useRef, PropsWithChildren } from 'react';
import Cookies from 'js-cookie';

export interface CookiesProviderType {
  activeTabMonitor?: string;
  setActiveTabMonitor: (value: string) => void;

  activeMonitor?: string;
  setActiveMonitor: (value: string) => void;

  healthcareFacilitySelector?: string;
  setHealthcareFacilitySelector: (value: string) => void;

  selectedCompany?: string;
  setSelectedCompany: (value?: string) => void;
}

const emptyHandler = () => {
  // typing purpose
};

export const CookiesContext = React.createContext({
  activeTabMonitor: undefined,
  setActiveTabMonitor: emptyHandler,
  activeMonitor: undefined,
  setActiveMonitor: emptyHandler,
  healthcareFacilitySelector: undefined,
  setHealthcareFacilitySelector: emptyHandler,
  selectedCompany: undefined,
  setSelectedCompany: emptyHandler,
} as CookiesProviderType);

const ActiveTabMonitor = 'active-tab-monitor';
const ActiveMonitor = 'active-monitor';
const HealthcareFacilitySelector = 'Healthcare-facility-selector';
const SelectedCompany = 'spd-selected-company';

export const onLogout = () => {
  Cookies.remove(ActiveTabMonitor);
  Cookies.remove(ActiveMonitor);
  Cookies.remove(HealthcareFacilitySelector);
  Cookies.remove(SelectedCompany);
};

export const CookiesProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [cookiesState, setCookiesState] = useState(
    new Map<string, string | undefined>(),
  );
  const loadingRef = useRef(false);

  const rawset = (name: string, value: string) => {
    Cookies.set(name, value, {
      sameSite: 'None',
      secure: true,
      path: '/',
    });
  };

  const set = (name: string, value: string) => {
    rawset(name, value);
    const newState = new Map(cookiesState);
    newState.set(name, value);
    setCookiesState(newState);
  };

  useEffect(() => {
    if (loadingRef.current) {
      return;
    }

    const map = new Map<string, string | undefined>();
    map.set(ActiveTabMonitor, Cookies.get(ActiveTabMonitor));
    map.set(ActiveMonitor, Cookies.get(ActiveMonitor));
    map.set(
      HealthcareFacilitySelector,
      Cookies.get(HealthcareFacilitySelector),
    );
    map.set(SelectedCompany, Cookies.get(SelectedCompany));
    setCookiesState(map);
  }, []);

  return (
    <CookiesContext.Provider
      value={{
        activeTabMonitor: cookiesState.get(ActiveTabMonitor),
        setActiveTabMonitor: (value: string) => set(ActiveTabMonitor, value),
        activeMonitor: cookiesState.get(ActiveMonitor),
        setActiveMonitor: (value: string) => set(ActiveMonitor, value),
        healthcareFacilitySelector: cookiesState.get(
          HealthcareFacilitySelector,
        ),
        setHealthcareFacilitySelector: (value: string) =>
          set(HealthcareFacilitySelector, value),
        selectedCompany: cookiesState.get(SelectedCompany),
        setSelectedCompany: (value?: string) => {
          if (value) {
            set(SelectedCompany, value);
          } else {
            Cookies.remove(SelectedCompany);
          }
        },
      }}
    >
      {children}
    </CookiesContext.Provider>
  );
};
